export function downloadFile(file: Blob, name: string) {
  const url = window.URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

/*
 * Safari/iOS hack:
 * window.open doesn't work inside an async function flow.
 * we're creating an helper function that provide a new tab and then attach the new url.
 */
export function createNewWindowTab() {
  const newWindowTab = window.open('about:blank', '_blank');
  return {
    open(url: string) {
      if (newWindowTab) {
        newWindowTab.location = url;
      }
    },
    close() {
      if (newWindowTab) {
        newWindowTab.close();
      }
    },
  };
}
